module.exports = __webpack_public_path__ + "assets/images/how-it-works.87206cf2082c58cbec3b689bdd599e71.png";